export const ActivityMonitorConstants = {
    ACTIVITY_CHECK_INTERVAL_SECONDS: 10,
    ACTIVITY_TIME_TO_WARNING_SECONDS: 15 * 60,
    ACTIVITY_TIME_TO_LOGOUT_SECONDS: 5 * 60,
    ACTIVITY_COUNTDOWN_INTERVAL_MS: 100
};